module.exports = __webpack_public_path__ + "static/media/apercu-bold.b015bfbd.woff";